import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlignHorizontalCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"align-horizontal-center, alignment"} maskId="square-filled-radius-0-stroke-1-IconAlignHorizontalCenter"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM11.5 17H12.5V7H11.5V17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAlignHorizontalCenter;
